<div class="container" *ngIf="isDbError" style="margin-top: 50px;">
    <p style="font-size: 16pt;">
        Application is temporarily out of service, please check back soon
    </p>
</div>
<div class="container" *ngIf="campaign && !isDbError" id="appframe">
    <!-- <div>
        <div *ngFor="let p of [].constructor(stepCountMax); let k=index">
            <span (click)="setPage(k)" style="font-style: 16px;color: red;">{{k}}</span>
        </div>
    </div> -->

        <!-- <button type="button" class="btn btn-outline-primary" *ngIf="stepCount===0" (click)="stepCount=1;isNextButtonVisible=true;isBackButtonVisible=true;cdr.detectChanges();">Go To Step 1</button> -->
    <!-- <div class="d-flex justify-content-start" *ngIf="stepCount>0" style="margin-bottom: 50px;">
        <div class="step-box" [style.background-color]="stepColor(1)">
            <h5>Step 1</h5>
            <span>Contact Info</span>
        </div>
        <div class="step-box" [style.background-color]="stepColor(2)">
            <h5>Step 2</h5>
            <span>Tree Preferences</span>
        </div>
        <div class="step-box" [style.background-color]="stepColor(3)">
            <h5>Step 3</h5>
            <span>Tree Pledge and Waiver</span>
        </div>
        <div class="step-box" [style.background-color]="stepColor(4)">
            <h5>Step 4</h5>
            <span>Payment</span>
        </div>
    </div> -->
    <div *ngIf="stepCount>0 && stepCount<=4" class="d-flex justify-content-center" style="max-width: 700px;margin-top: 20px;;">
        <h5 style="color: black">Step {{stepCount}} of 4</h5>
    </div>
        <app-gate-keeper [model]="campaign.gatekeepers"  (answered)="onAnswered()"
        *ngIf="stepFormVisible(0)"></app-gate-keeper>
        <app-step1 [model]="treesViewModel"  *ngIf="stepFormVisible(1)"></app-step1>
        <app-step2 [model]="treesViewModel"  *ngIf="stepFormVisible(2)"></app-step2>
        <app-step3 [model]="treesViewModel"   *ngIf="stepFormVisible(3)"></app-step3>
        <app-step4 [model]="treesViewModel"  (placeOrder)="onPlaceOrder()" *ngIf="stepFormVisible(4)"></app-step4>
        <div *ngIf="stepFormVisible(5)">
            <div [innerHTML]="request.mail | safeHtml" style="margin-bottom: 30px;"></div>
        </div>
    <div class="row" style="margin-top: 60px;max-width: 400px;" *ngIf="stepCount<=4">
        <div class="col text-right">
            <button type="button" class="btn btn-warning btn-lg" [attr.disabled]="isBackButtonVisible ? null : true"
             (click)="back()" >< Back</button>
        </div>
        <div class="col">
            <button type="button" class="btn btn-warning btn-lg" (click)="next()"
            [attr.disabled]="nextVisible() ? null : true">Next ></button>
        </div>
    </div>
    <!-- <div [attr.disabled]="!isBackButtonVisible"  style="margin-top: 60px;">
        <button type="button" class="btn btn-warning btn-lg" (click)="next()"
        [attr.disabled]="isNextButtonVisible">Next ></button>
    </div> -->
</div>
